// extracted by mini-css-extract-plugin
export default {"current-temperature":"CurentTemperature_current-temperature__wwF1d"};